// Lib
import { includes } from 'lodash/fp';

// Constants
import { BLACKLISTED_EXTENSIONS, BLACKLISTED_FILENAMES } from './fileConstants';
import getFileExtension from './getFileExtension';
import { ERROR_LOCALE_KEYS } from '../error/errorLocaleKeys';

// Types
import FileValidationError, { FileValidationErrorCodes } from '../error/FileValidationError';

export const validateFilename = (filename: string): FileValidationError | null => {
    if (!filename) {
        return new FileValidationError({
            code: FileValidationErrorCodes.NO_FILENAME,
            message: 'A filename must be provided',
            errorLocaleKey: ERROR_LOCALE_KEYS.FILE.NO_FILENAME,
        });
    }

    if (includes(filename, BLACKLISTED_FILENAMES)) {
        return new FileValidationError({
            code: FileValidationErrorCodes.INVALID_FILENAME,
            message: `The filename "${filename}" is not allowed`,
            errorLocaleKey: ERROR_LOCALE_KEYS.FILE.INVALID_FILENAME,
            context: { filename },
        });
    }

    const periodIndex = filename.lastIndexOf('.');
    if (periodIndex === 0) {
        return new FileValidationError({
            code: FileValidationErrorCodes.INVALID_FILENAME,
            message: 'Dot files are not allowed',
            errorLocaleKey: ERROR_LOCALE_KEYS.FILE.DOT_FILES,
        });
    }

    const extension = getFileExtension(filename);
    const isInvalidExtension = includes(extension, BLACKLISTED_EXTENSIONS);
    if (isInvalidExtension) {
        return new FileValidationError({
            code: FileValidationErrorCodes.INVALID_EXTENSION,
            message: `.${extension} files are not supported`,
            errorLocaleKey: ERROR_LOCALE_KEYS.FILE.INVALID_EXTENSION,
            context: { extension },
        });
    }

    return null;
};
